import React from "react";
import style from './rangeSlider.module.scss';
import toPersianNumber from "../../../helpers/actions/toPersianNumber";
import { numberWithCommas } from "../../../helpers/actions/splitNumberWithComma";

const RangeSlider = (props) => {

    const calculateLoaderWidth = () => {
        let saleDiff = (Number(props.userProfit) - Number(props.minProfit))
        let rangeDiff = (Number(props.maxProfit) - Number(props.minProfit))
        let eachStep = rangeDiff / 10
        let calculatedStep = (saleDiff / eachStep) < 1 ? 1 : ((saleDiff / eachStep) < 10 ? parseInt(saleDiff / eachStep) : 10)
        if (props.userProfit && props.userProfit === props.minProfit) {
            return 1 * 10
        }
        if (props.userProfit && props.userProfit === props.maxProfit) {
            return 10 * 10
        }
        return (calculatedStep + 1) * 10
    }

    return (
        <div className={style.wrapper}>
            <div className={style.circleLeft}>
                {
                    <div className={style.minProfit}>
                        <div className={style.triangle}></div>
                        <div className={style.rectangle}>
                            <div className={style.text}>حداقل فروش:
                                <p className={style.profit}>{toPersianNumber(numberWithCommas(props.minProfit))}</p>
                            </div>
                            {
                                props.userProfit && props.userProfit === props.minProfit &&
                                <div className={style.text}> فروش شما:
                                    <p className={style.profit}>{toPersianNumber(numberWithCommas(props.userProfit))}</p>
                                </div>
                            }
                        </div>
                    </div>}

            </div>
            <div className={style.line}>
                <div className={style.indicatorWrapper} style={{
                    backgroundColor: props.bgColor,
                    left: calculateLoaderWidth() + "%"
                }}>
                    <div className={style.indicator}>
                        {<div className={style.userProfit}>
                            <div className={style.triangle}></div>
                            <div className={style.rectangle}>
                                <div className={style.text}>فروش شما:
                                    <p className={style.profit}>{toPersianNumber(numberWithCommas(props.userProfit))}</p>
                                </div>
                            </div>
                        </div>}

                    </div>
                </div>
            </div>
            <div className={style.circleRight}>
                {
                    <div className={style.maxProfit}>
                        <div className={style.triangle}></div>
                        <div className={style.rectangle}>
                            <div className={style.text}>حداکثر فروش:
                                <p className={style.profit}>{toPersianNumber(numberWithCommas(props.maxProfit))}</p>
                            </div>
                            {
                                props.userProfit && props.userProfit === props.maxProfit &&
                                <div className={style.text}> فروش شما:
                                    <p className={style.profit}>{toPersianNumber(numberWithCommas(props.userProfit))}</p>
                                </div>
                            }
                        </div>
                    </div>}

            </div>
        </div>
    )
}
export default RangeSlider

